import * as Immutable from 'immutable';
import { createSelector } from 'reselect';

import { prop } from '../../../common/utils/immutableHelper';
import { isContent } from '../../../common/elements/utils/elementTypeUtils';

// Constants

import { ElementType } from '../../../common/elements/elementTypes';
import { ELEMENT_COUNT_WARNING_START } from './elementCountConstants';
import type { ReduxState } from '../../types/reduxTypes';

type ImElementCountMap = Immutable.Map<ElementType, number>;

export const elementCountSelector: (state: ReduxState) => ImElementCountMap = prop('elementCount');

export const contentElementCountSelector = createSelector(elementCountSelector, (elementCount) =>
    elementCount.filter((_, type) => isContent(type)),
);

export const contentTotalCountSelector = createSelector(contentElementCountSelector, (elementCount) =>
    elementCount.reduce((count: number = 0, typeCount: number = 0) => count + typeCount, 0),
);

export const fileCountSelector = createSelector(
    contentElementCountSelector,
    (elementCount) => elementCount.get(ElementType.FILE_TYPE) || 0,
);

export const contentTotalLimitSelector = (state: ReduxState): number =>
    state.getIn(['app', 'currentUser', 'contentLimit', 'current']);
export const contentLimitExceededSelector = (state: ReduxState): boolean =>
    state.getIn(['app', 'currentUser', 'contentLimit', 'exceeded']) || false;

export const isWorkspaceFull = (contentTotalCount: number, contentTotalLimit: number) =>
    contentTotalCount >= contentTotalLimit;

export const isWorkspaceAlmostFull = (contentTotalCount: number, contentTotalLimit: number) =>
    contentTotalCount >= contentTotalLimit - ELEMENT_COUNT_WARNING_START;
